type DSPSOpts = 'AWZ' | 'TAP' | 'MAG' | 'TTD';

type SyncResult = {
  [param: string]: string;
};

export interface ISyncCookieParams {
  amperwaveStationId?: number;
  enabledDSPS?: Array<DSPSOpts>;
  gdpr?: boolean;
  gdprConsent?: string;
  gpp?: string;
  tapStationId?: string;
  timeout?: number;
  usPrivacy?: string;
  userId?: string;
  magnitePartnerKey?: string;
  magniteEndpoint?: string;
  ttdPId?: string;
  ttdId?: string;
};

/**
 * Uses Amerpwave's provided User Cookie Sync Script (loaded in index.html) to sync cookies across
 * AdWiz, TAP, Magnite, and TradeDesk. Please refer to https://user-sync.amperwave-qa.int.audacy.com/sync/index.d.ts
 * for more information on the above interface and its members.
 */
export default async function syncCookies(params: ISyncCookieParams): Promise<SyncResult | null> {
  // @ts-ignore
    if (!window.syncCookies) {
      return null;
    }

    const defaultParams: Partial<ISyncCookieParams> = {
      timeout: 1000, // Default timeout in milliseconds - this is to prevent the script from forever waiting to resolve the syncCookies promise
    };

    const mergedParams: ISyncCookieParams = {
      ...defaultParams,
      ...params,
    };

    try {
      // @ts-ignore
      return await window.syncCookies(mergedParams);
    } catch (e) {
      console.error('Failed to sync user cookies.', e);
      return null;
    }
}
